import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://yzppqlzrvonooqffpeuu.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl6cHBxbHpydm9ub29xZmZwZXV1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU2Mjg0NDQsImV4cCI6MjA3MTIwNDQ0NH0.HYt13_EDD-OJNCIbhpyYy2iOx4vVYhIDlCO6Jbbo14o'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY || SUPABASE_URL.includes('PROJECT-ID')) {
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

// Test connection and create tables if they don't exist
const initializeDatabase = async () => {
  try {
    console.log('🔄 Initializing database...');
    
    // Test basic connection
    const { data: connectionTest, error: connectionError } = await supabase
      .from('users_crm_2025')
      .select('id')
      .limit(1);

    if (connectionError) {
      console.warn('⚠️ Database connection check warning:', connectionError.message);
    } else {
      console.log('✅ Database connection successful');
    }

    // Repair roles and insert defaults
    await repairUserRoles();
    await insertDefaultData();
    
    return true;
  } catch (error) {
    console.error('❌ Database initialization failed:', error);
    return false;
  }
};

const repairUserRoles = async () => {
  try {
    const { data: roles, error: rolesError } = await supabase
      .from('roles_crm_2025')
      .select('id, name');

    if (rolesError || !roles) return;

    const roleMap = {};
    roles.forEach(r => {
      if (r.name) roleMap[r.name.toLowerCase()] = r.id;
    });

    // Link users to role IDs if missing
    for (const [roleName, roleId] of Object.entries(roleMap)) {
      await supabase.from('users_crm_2025')
        .update({ role_id: roleId })
        .eq('role', roleName)
        .is('role_id', null);
    }
  } catch (error) {
    console.error('Error repairing user roles:', error);
  }
};

const insertDefaultData = async () => {
  try {
    // 1. Insert Departments
    const defaultDepartments = [
      { name: 'Information Technology' },
      { name: 'Human Resources' },
      { name: 'Sales & Marketing' }
    ];
    
    for (const dept of defaultDepartments) {
      await supabase.from('departments_crm_2025').upsert(dept, { onConflict: 'name' });
    }

    // 2. Settings
    const { data: settings } = await supabase.from('settings_crm_2025').select('id').limit(1);
    if (!settings || settings.length === 0) {
      await supabase.from('settings_crm_2025').insert([{ 
        company_name: 'Your Agency', 
        company_email: 'info@youragency.com',
        reminder_days: 15 
      }]);
    }
  } catch (error) {
    console.error('❌ Error inserting default data:', error);
  }
};

// Start initialization immediately
initializeDatabase();

export default supabase;